module.exports = __webpack_public_path__ + "img/index-cover-mobile-bg.d0b93185.png";